module.exports = __webpack_public_path__ + "img/gamma3_ex_logo_old.eb28ba68.png";